import React, { useContext, useEffect } from "react";
import "./NewsHome.css";
import "./ResponsiveNews.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { dataContext } from "../../context/DataContextProviderr";
import { filterKey, truncate } from "../../helper/function";
import ScrollAnimation from "react-animate-on-scroll";

const NewsHome = () => {
  const {
    pageNumNews,
    pageSizeNews,
    setPageSizeNews,
    pageCountNews,
    setPageNumNews,
    isLoadingNews,
    allNews,
    homeNews,
    allWebParts,
  } = useContext(dataContext);
  const navigate = useNavigate();
  const navigateHandler = (path) => {
    navigate(path);
  };
  const filterNews = allWebParts?.filter((x) => x.uniqueName === "news");
  let delay = 0;
  return (
    <div className="news-home">
      <div className="top">
        <div className="content">
          <div className="logo">
            <img src="/pic/logo.png" alt="logo" />
            <p>اخبار ما</p>
          </div>
          <div className="title">
            <p>{filterKey(filterNews, "title")?.map((item) => item.Value)}</p>
          </div>
          <div className="description">
            <p>
              {filterKey(filterNews, "description")?.map((item) => item.Value)}
            </p>
          </div>
          <div className="button-container">
            <Button onClick={() => navigateHandler("/news")}>مشاهده بیشتر</Button>
          </div>
        </div>
      </div>
      <div className="bottom">
        {homeNews &&
          homeNews?.map((item, index) => {
            delay = delay + 250;
            return (
              <ScrollAnimation
                // animateIn="bounceIn"
                animateIn="slideInDown"
                // animateIn="zoomIn"
                delay={delay}
                className="cardd"
                key={index}
              >
                <div className="img-container">
                  <img
                    src={`${
                      window.Configs["ui-base-url"]
                    }/Api/V1/ui/Content/Image?entityName=2&imageName=${
                      item?.image && item?.image
                    }`}
                    alt="pic-news"
                  />
                </div>
                <div className="contentt">
                  <p className="p">{truncate(item.title, 65)}</p>
                  <p className="span">{truncate(item.summary, 210)}</p>
                  <span className="date">{item.createDate}</span>
                </div>
              </ScrollAnimation>
            );
          })}
      </div>
    </div>
  );
};

export default NewsHome;
